function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { forwardRef, useCallback } from 'react';
import { useDeferredApi } from '@deephaven/jsapi-bootstrap';
import { ChartModelFactory } from '@deephaven/chart';
import { IrisGridUtils } from '@deephaven/iris-grid';
import { getTimeZone, store } from '@deephaven/redux';
import { assertNotNull } from '@deephaven/utils';
import { isChartPanelDehydratedProps, isChartPanelTableMetadata } from "./panels/index.js";
import ConnectedChartPanel from "./panels/ChartPanel.js";
import { jsx as _jsx } from "react/jsx-runtime";
function createChartModel(_x, _x2, _x3, _x4) {
  return _createChartModel.apply(this, arguments);
}
function _createChartModel() {
  _createChartModel = _asyncToGenerator(function* (dh, metadata, panelFetch, panelState) {
    var settings = {};
    var tableName = '';
    var tableSettings = {};
    if (isChartPanelTableMetadata(metadata)) {
      settings = metadata.settings;
      tableName = metadata.table;
      tableSettings = metadata.tableSettings;
    }
    if (panelState != null) {
      if (panelState.tableSettings != null) {
        tableSettings = panelState.tableSettings;
      }
      if (panelState.table != null) {
        tableName = panelState.table;
      }
      if (panelState.settings != null) {
        settings = _objectSpread(_objectSpread({}, settings), panelState.settings);
      }
    }
    if (tableName != null && tableName !== '') {
      var table = yield panelFetch();
      new IrisGridUtils(dh).applyTableSettings(table, tableSettings, getTimeZone(store.getState()));
      return ChartModelFactory.makeModelFromSettings(dh, settings, table);
    }
    var figure = yield panelFetch();
    return ChartModelFactory.makeModel(dh, settings, figure);
  });
  return _createChartModel.apply(this, arguments);
}
export var ChartPanelPlugin = /*#__PURE__*/forwardRef((props, ref) => {
  var panelState = isChartPanelDehydratedProps(props) ? props.panelState : undefined;
  var panelFetch = props.fetch,
    metadata = props.metadata,
    localDashboardId = props.localDashboardId;
  assertNotNull(metadata);
  var _useDeferredApi = useDeferredApi(metadata),
    _useDeferredApi2 = _slicedToArray(_useDeferredApi, 2),
    dh = _useDeferredApi2[0],
    error = _useDeferredApi2[1];
  var makeModel = useCallback(/*#__PURE__*/_asyncToGenerator(function* () {
    if (error != null) {
      throw error;
    }
    if (dh == null) {
      return new Promise(() => {
        // We don't have the API yet, just return an unresolved promise so it shows as loading
      });
    }
    return createChartModel(dh, metadata, panelFetch, panelState);
  }), [dh, error, metadata, panelFetch, panelState]);
  return /*#__PURE__*/_jsx(ConnectedChartPanel, _objectSpread(_objectSpread({
    ref: ref
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, props), {}, {
    metadata: metadata,
    localDashboardId: localDashboardId,
    makeModel: makeModel
  }));
});
ChartPanelPlugin.displayName = 'ChartPanelPlugin';
export default ChartPanelPlugin;
//# sourceMappingURL=ChartPanelPlugin.js.map